module.exports = Em.Mixin.create(require('./dirty-confirmation'), {
    hasConfirmed: false,

    isDirty: function(model) {
        return model.get('isDirty')
    },

    rollback: function(model) {
        model.rollback()
    },

    // React's shared-history blocker (useReactEmberRouterConnection.ts) has no visibility into
    // this mixin's own model-dirty check. Without telling it too, a browser Back could get
    // through at the real URL/history level even while Ember aborts its own transition and shows
    // this dialog, desyncing the address bar from Ember's route. Dispatch the same native event
    // dirtyRouteContext.tsx uses for React forms.
    _setBrowserBackButtonBlocked: function(value) {
        window.dispatchEvent(new CustomEvent('block-browser-back-button-requested', {
            detail: { sourceId: 'ember-dirty-route', value: value }
        }))
    },

    deactivate: function() {
        this._super.apply(this, arguments)
        this._setBrowserBackButtonBlocked(false)
    },

    actions: {
        willTransition: function(transition) {
            this._super(transition)
            var self = this

            var controller = this.get('controller')
            var model = controller.get('model')

            if (model.get('isDestroying') || model.get('isDeleted')) {
                return
            }

            if (this.hasConfirmed || !this.isDirty(model, controller)) {
                this.hasConfirmed = false
                // The model may have been dirty and blocked earlier in this same route activation
                // (Stay leaves the block armed), then saved in place without ever navigating away.
                // Nothing else would clear that stale block, so a later Back would stay stuck.
                self._setBrowserBackButtonBlocked(false)
                // Rollback in case it's a new and clean record
                transition.then(function() {
                    self.rollback(model, controller)
                })
                return
            }

            self._setBrowserBackButtonBlocked(true)

            // Abort the transition
            transition.abort()

            // Show confirm window (if not already open)
            var win = this._getConfirmNavigationWindow()
            if (win) {
                return win
                    .then(function() {
                        self.hasConfirmed = true
                        self._setBrowserBackButtonBlocked(false)
                        transition.retry()
                            .then(function() {
                                self.rollback(model, controller)
                            })
                    })
            }
        }
    }
})
